import { type ReactNode } from 'react';
import { Flame } from 'lucide-react';
import type { Cfg } from '../hooks/use-settings-state';
import { SettingsCard } from './settings-card';
import { NumField } from './settings-field';

type P = { cfg: Cfg; set: (k: keyof Cfg, v: string | number) => void };
type F = { label: string; key: keyof Cfg; unit: string; tip: string };

const FIELDS: F[] = [
  {
    label: 'Mínimo diario',
    key: 'daily_minimum_leads',
    unit: 'creadores',
    tip: 'Creadores/día para mantenerse activo',
  },
  {
    label: 'Umbral top tier',
    key: 'top_tier_threshold',
    unit: 'creadores',
    tip: 'Creadores/día para sumar al top tier',
  },
  {
    label: 'Días/semana top tier',
    key: 'top_tier_days_required',
    unit: 'días',
    tip: 'Días por semana que necesita para top tier',
  },
  {
    label: 'Días para pre-ban',
    key: 'pre_ban_failed_days_threshold',
    unit: 'días',
    tip: 'Días fallados en la semana (lun-dom) → pre-ban',
  },
  {
    label: 'Gracia pre-ban',
    key: 'pre_ban_grace_days',
    unit: 'días',
    tip: 'Días para recuperarse antes del ban definitivo',
  },
];

export function ActivityCard({ cfg, set }: P): ReactNode {
  return (
    <SettingsCard
      icon={<Flame size={16} />}
      title="Actividad y sanciones"
      subtitle="Mínimos diarios, top tier y reglas de pre-ban"
    >
      {FIELDS.map((f) => (
        <NumField
          key={f.key}
          label={f.label}
          value={cfg[f.key] as number}
          onChange={(v) => set(f.key, v)}
          unit={f.unit}
          tip={f.tip}
        />
      ))}
    </SettingsCard>
  );
}
